import { Injectable } from '@angular/core';
import { SHA256 } from 'crypto-js';
import { ModeTranslate, StepsClientTypes, StepsNotClientTypes } from 'src/app/shared/enums';
import { environment } from '../../../environments/environment';
import { AccountFormatService } from '../account-format.service';

declare global {
  interface Window {
    DD_RUM: any;
  }
}
@Injectable({
  providedIn: 'root'
})

export class DatadogService {

  constructor(private accountFormatService: AccountFormatService) { }

  loadScript = (datadogConfig): Promise<any> => {
    if (!datadogConfig) {
      return Promise.resolve();
    }
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('id', 'dataDog-script');
    scriptTag.type = 'text/javascript';
    scriptTag.text = `
    (function(h,o,u,n,d) {
      h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
      d=o.createElement(u);d.async=1;d.src=n
      n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
      })(window,document,'script','https://www.datadoghq-browser-agent.com/datadog-rum-v4.js','DD_RUM')
      DD_RUM.onReady(function() {
        DD_RUM.init({
          clientToken: '${environment.datadog.clientToken}',
          applicationId:  '${environment.datadog.aplicationId}',
          site: '${environment.datadog.site}',
          env: '${environment.production}',
          service: '${environment.datadog.service}',
          version: '1.0.0',
          sampleRate: ${datadogConfig.sampleRate},
          premiumSampleRate: 0,
          trackViewsManually: true,
          defaultPrivacyLevel: 'mask-user-input'
        });
      DD_RUM.startSessionReplayRecording();
    })`;
    document.body.appendChild(scriptTag);
    return Promise.resolve();
  }

  addContextUser = (hash: string): void => {
    if (window.DD_RUM !== undefined) {
      window.DD_RUM.onReady(() => {
        const hashValue = SHA256(hash).toString();
        window.DD_RUM.addRumGlobalContext('global', { hashID: hashValue });
        window.DD_RUM.setUser({ id: hashValue });
      });
    }
  }
  addCustomEvent = (eventCustom: string, mode: string, extraMetaData?: any): void => {
    extraMetaData.mode = ModeTranslate[mode.replace('-', '_')];
    const metaData = {
      value: eventCustom,
      ...extraMetaData
    };
    if (window.DD_RUM !== undefined) {
      console.info('<<<<<< Datadog: ', eventCustom, metaData);
      window.DD_RUM.onReady(() => {
        window.DD_RUM.addAction(eventCustom, metaData);
      });
    }
  }

  addCustomError = (error: Error, eventName: string, mode: string, extraMetaData?: any): void => {
    extraMetaData.mode = ModeTranslate[mode.replace('-', '_')];
    const metaData = {
      value: eventName,
      ...extraMetaData
    };
    if (window.DD_RUM !== undefined) {
      console.info('<<<<<< Datadog: ', error, metaData);
      window.DD_RUM.onReady(() => {
        window.DD_RUM.addError(error, metaData);
      });
    }
  }

  addPageView(step: StepsClientTypes | StepsNotClientTypes) {
    const mode = (Object as any).values(StepsClientTypes).includes(step) ?
    environment.mode === 'PF' ? 'ej' : 'pr' :
    environment.mode === 'WEB-PF' ? 'ejp' : 'pu';
    const regex = /(?=[A-Z])/;
    const currentStep = step.split(' ')[1].split(regex).join('-').toLowerCase();
    const pageView = `${mode}-onboarding-account-${currentStep}-` + this.accountFormatService.getNameGA();
    if (window.DD_RUM !== undefined) {
      console.info('<<<<<< Datadog: ', pageView);
      window.DD_RUM.onReady(() => {
        window.DD_RUM.startView({
          name: pageView
        });
      });
    }
  }
}
